import DefaultLayout from "@/layouts/DefaultLayout";
import { client } from "@/graphql/client";
import { ApolloProvider } from "@apollo/client";
import { CacheProvider } from "@emotion/react";
import { theme } from "@/layouts/createTheme";
import { ThemeProvider } from "@mui/material/styles";
import AppHead from "@/components/base/misc/AppHead";
import { AppLayoutProvider } from "@/layouts/components/layoutContext";
import { AppGlobalProvider } from "@/components/base/app/AppGlobalProvider";
import { StyledEngineProvider } from "@mui/material/styles";
import * as Sentry from "@sentry/nextjs";
import { ErrorBoundary } from "@sentry/react";
import createEmotionCache from "@/utils/createEmotionCache";

function FallbackComponent({ error, resetErrorBoundary }) {
    console.log("------------------", error);
    return (
        <div role="alert" style={{ padding: "20px", textAlign: "right" }}>
            {" "}
            <h2>مشکلی پیش اومد!</h2>
            <p>خطا: {error?.message}</p>
            <button onClick={resetErrorBoundary}>تلاش دوباره</button>
        </div>
    );
}

const clientSideEmotionCache = createEmotionCache();

export default function App({
    Component,
    pageProps,
    emotionCache = clientSideEmotionCache,
}) {
    let Layout;
    if (Component.getLayout) {
        Layout = Component.getLayout(<Component {...pageProps} />);
    } else {
        Layout = (
            <AppLayoutProvider>
                <DefaultLayout title={Component.title}>
                    <Component {...pageProps} />
                </DefaultLayout>
            </AppLayoutProvider>
        );
    }

    return (
        <>
            <ErrorBoundary
                fallback={<FallbackComponent />}
                onError={(error, errorInfo) => {
                    Sentry.captureException(error, { extra: errorInfo });
                }}
                onReset={() => {
                    window.location.reload();
                }}
            >
                <CacheProvider value={emotionCache}>
                    <AppHead />
                    <ThemeProvider theme={theme}>
                        <ApolloProvider client={client}>
                            <StyledEngineProvider>
                                <AppGlobalProvider>{Layout}</AppGlobalProvider>
                            </StyledEngineProvider>
                        </ApolloProvider>
                    </ThemeProvider>
                </CacheProvider>
            </ErrorBoundary>
        </>
    );
}
